import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class OnshapeNameMappingEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "OnshapeNameMapping";
        this.primaryEnterpriseComponent = "OnshapeNameMapping";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "OnshapeNameMapping";
        eom.enterpriseComponent = "OnshapeNameMapping";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default OnshapeNameMappingEnterpriseObjectMetadata;